<template lang="pug">
    div.maintain-check
        template(v-if="isAutoX3MaintenanceCheck")
            div(style="text-align: center; margin-top: 40px") 当前门店已启用保养智能检测服务，请使用 CRM-APP进行检测结果提交
            div(style="text-align: center")
                img(
                    :src="APPqrcode"
                    style="margin: 5px auto; width: 120px; height: 120px;"
                )
                p 凯励程CRM APP下载
        template(v-if="!isAutoX3MaintenanceCheck")
            template(v-if="ignoreStatus && !isCompleteOrder")
                div.jump-tag 跳过
                div.info-operator 提交人：
                    span {{ detailData.maintenanceCheck.operatorName }} {{ detailData.maintenanceCheck.operatorPhone }} {{ detailData.maintenanceCheck.operateTime | dateFormat }}
            template(v-if="stashStatus || commitStatus || isCompleteOrder")
                el-form(
                    :model="formData"
                    :rules="rules"
                    ref="form"
                    :class="{'small-margin': commitStatus}"
                )
                    el-form-item(
                        :class="{'required-star': !commitStatus}"
                        label="报价金额："
                        prop="quotationMaterialAmount"
                    )
                        template(v-if="stashStatus || isCompleteOrder")
                            span 材料费(元)：
                            el-input(
                                style="width: 350px;"
                                maxlength="11"
                                v-model="formData.quotationMaterialAmount"
                                placeholder="请输入"
                            )
                        template(v-if="commitStatus")
                            span 材料费：{{ formData.quotationMaterialAmount | amountFormat }}
                            span(style="margin: 0 10px; position: relative; top: -1px") |
                            span 工时费：{{ formData.quotationPersonnelAmount | amountFormat }}
                    el-form-item(
                        v-if="stashStatus || isCompleteOrder"
                        label=""
                        prop="quotationPersonnelAmount"
                    )
                        span 工时费(元)：
                        el-input(
                            style="width: 350px;"
                            maxlength="11"
                            v-model="formData.quotationPersonnelAmount"
                            placeholder="请输入"
                        )
                    el-form-item(
                        :class="{'required-star': !commitStatus}"
                        label="成本金额："
                        prop="overhaulMaterialAmount"
                    )
                        template(v-if="stashStatus || isCompleteOrder")
                            span 材料费(元)：
                            el-input(
                                style="width: 350px;"
                                maxlength="11"
                                v-model="formData.overhaulMaterialAmount"
                                placeholder="请输入"
                            )
                        template(v-if="commitStatus")
                            span 材料费：{{ formData.overhaulMaterialAmount | amountFormat }}
                            span(style="margin: 0 10px; position: relative; top: -1px") |
                            span 工时费：{{ formData.overhaulPersonnelAmount | amountFormat }}
                    el-form-item(
                        v-if="stashStatus || isCompleteOrder"
                        label=""
                        prop="overhaulPersonnelAmount"
                    )
                        span 工时费(元)：
                        el-input(
                            style="width: 350px;"
                            maxlength="11"
                            v-model="formData.overhaulPersonnelAmount"
                            placeholder="请输入"
                        )
                    el-form-item.switch(
                        label=""
                        prop=""
                    )
                        div.switch-box
                            div.switch-item()
                                span(:class="{'switch-star': !commitStatus}") 是否订购配件：
                                el-switch(
                                    v-if="stashStatus || isCompleteOrder"
                                    v-model="formData.buyComponents"
                                )
                                span(v-if="commitStatus") {{ formData.buyComponents ? '是' : '否' }}
                            div.switch-item()
                                span(:class="{'switch-star': !commitStatus}") 是否钣金施工：
                                el-switch(
                                    v-if="stashStatus || isCompleteOrder"
                                    v-model="formData.sprayPaint"
                                )
                                span(v-if="commitStatus") {{ formData.sprayPaint ? '是' : '否' }}
                            div.switch-item()
                                span(:class="{'switch-star': !commitStatus}") 是否车辆喷漆：
                                el-switch(
                                    v-if="stashStatus || isCompleteOrder"
                                    v-model="formData.vehiclePainting"
                                )
                                span(v-if="commitStatus") {{ formData.vehiclePainting ? '是' : '否' }}
                    el-form-item.upload-pictures.margin-bottom-12(
                        :class="{'required-star': !commitStatus}"
                        label="检测凭证："
                        prop="checkPicture"
                    )
                        UploadFormItem(v-if="stashStatus || isCompleteOrder" @change="onPicChange" :asyncfileList="checkPictureFull", :limit="9")
                        div.images(v-if="commitStatus && checkPictureFull && checkPictureFull.length")
                            img(
                                v-for="(img, idx) in checkPictureFull"
                                :key="idx"
                                style="width: 78px; height: 78px; margin-right: 10px; margin-bottom: 10px"
                                :src="img.url"
                                @click="handleShowImage(img, checkPictureFull)"
                            )
                    el-form-item(
                        :class="{'padding-left': !commitStatus}"
                        label="预计交车时间："
                        prop="planDeliverDate"
                    )
                        div(v-if="stashStatus || isCompleteOrder")
                            el-date-picker(
                                v-model="formData.planDeliverDate"
                                type="date"
                                placeholder="请选择"
                                style="width: 430px;"
                            )
                        div(v-if="commitStatus") {{ formData.planDeliverDate| dateFormat('YYYY/MM/DD') | fieldVaild }}
                    el-form-item.upload-pictures(
                        :class="{'padding-left': !commitStatus}"
                        label="备注："
                        prop="checkRemark"
                    )
                        el-input(
                            v-if="stashStatus || isCompleteOrder"
                            v-model.trim="formData.checkRemark"
                            :rows="4"
                            style="width: 430px;"
                            resize="none"
                            type="textarea"
                            maxlength="100"
                            placeholder="请输入"
                            :show-word-limit="true"
                        )
                        div.remark-view(v-if="commitStatus") {{ formData.checkRemark | fieldVaild }}
                div.info-operator(v-if="commitStatus") 提交人：
                    span {{ detailData.maintenanceCheck.operatorName }} {{ detailData.maintenanceCheck.operatorPhone }} {{ detailData.maintenanceCheck.operateTime | dateFormat }}
                span.dialog-footer(v-if="stashStatus || isCompleteOrder" slot="footer" style="margin-top: 20px")
                    el-popover(placement="bottom" width="172" v-model="visible" popper-class="padding-16 text-left")
                        div(style="text-align: right; margin: 0")
                            p 确认跳过当前处理？
                            el-button.pop-button(@click="visible = false") 取消
                            el-button.pop-button.primary(@click="handleIgnore") 确定
                        el-button.button(slot="reference" round :loading="loading" v-if="!isCompleteOrder") 跳过
                    el-button.button(round :loading="loading" @click="handleStash" v-if="!isCompleteOrder") 保存
                    el-popover(placement="bottom" width="190" v-model="visible2" popper-class="padding-16 text-left")
                        div(style="text-align: right; margin: 0")
                            p 确认提交当前处理结果？
                            el-button.pop-button(@click="visible2 = false") 取消
                            el-button.pop-button.primary(@click="handleSubmit") 确定
                        el-button.button(slot="reference" round type="primary" :loading="loading") 提交
</template>

<script>
import { sonarUrlUtils } from '@/utils';
import UploadFormItem from '@/components/Common/UploadFormItem.vue';
import workOrderMixin from '../../../mixins/workOrder';

export default {
    name: 'MaintenanceCheck',
    components: {
        UploadFormItem,
    },
    props: {
        detailData: {
            type: Object,
            default: () => {},
        },
        loading: {
            type: Boolean,
            default: false,
        },
        formType: {
            type: String,
            default: 'resolve',
        },
    },
    mixins: [workOrderMixin],
    data() {
        const validateAmount = (rule, value, callback) => {
            const amountMap = {
                quotationMaterialAmount: '报价材料',
                quotationPersonnelAmount: '报价工时',
                overhaulMaterialAmount: '成本材料',
                overhaulPersonnelAmount: '成本工时',
            };
            const amountReg = /^([1-9]\d*|0)((\.\d{1,2})?)$/;
            if (!this.isStash && !value) {
                callback(new Error(`请输入${amountMap[rule.field]}金额`));
            } else if (value && !amountReg.test(value)) {
                callback(new Error(`请输入正确的${amountMap[rule.field]}金额`));
            } else if (value > 100000000) {
                callback(new Error(`${amountMap[rule.field]}金额最大不超过100000000`));
            } else {
                callback();
            }
        };
        const validateDamageImage = (rule, value, callback) => {
            if (!this.isStash && (!this.checkPic || !this.checkPic.length)) {
                callback(new Error('请上传检测凭证图片'));
            } else {
                callback();
            }
        };
        return {
            formData: {
                stepName: 'MAINTENANCE_CHECK',
                quotationMaterialAmount: '',
                quotationPersonnelAmount: '',
                overhaulMaterialAmount: '',
                overhaulPersonnelAmount: '',
                buyComponents: false,
                sprayPaint: false,
                vehiclePainting: false,
                checkPicture: [],
                planDeliverDate: null,
                checkRemark: '',
            },
            rules: {
                quotationMaterialAmount: [
                    {
                        validator: validateAmount,
                        trigger: 'blur',
                    },
                ],
                quotationPersonnelAmount: [
                    {
                        validator: validateAmount,
                        trigger: 'blur',
                    },
                ],
                overhaulMaterialAmount: [
                    {
                        validator: validateAmount,
                        trigger: 'blur',
                    },
                ],
                overhaulPersonnelAmount: [
                    {
                        validator: validateAmount,
                        trigger: 'blur',
                    },
                ],
                checkPicture: [
                    {
                        trigger: 'change',
                        validator: validateDamageImage,
                    },
                ],
            },
            checkPictureFull: [],
            checkPic: [],
            isStash: false,
            visible: false,
            visible2: false,
        };
    },
    computed: {
        stashStatus() {
            return !this.detailData.maintenanceCheck || this.detailData.maintenanceCheck.itemStatus === 'STASH';
        },
        ignoreStatus() {
            return this.detailData.maintenanceCheck && this.detailData.maintenanceCheck.itemStatus === 'IGNORE';
        },
        commitStatus() {
            return this.detailData.maintenanceCheck && this.detailData.maintenanceCheck.itemStatus === 'COMMIT';
        },
        isAutoX3MaintenanceCheck() {
            return (this.detailData.upcomingList && this.detailData.upcomingList.includes('AUTOX3_MAINTENANCE_CHECK')) || this.detailData.autox3MaintenanceCheck;
        },
        APPqrcode() {
            return sonarUrlUtils.gaiaApp;
        },
        isCompleteOrder() {
            return this.formType === 'complete';
        },
    },
    methods: {
        initFormData() {
            if (!this.detailData.maintenanceCheck || this.detailData.maintenanceCheck.itemStatus === 'IGNORE') return;
            const data = this.detailData.maintenanceCheck.content || {};
            this.formData = Object.assign({}, this.formData, data);
            this.fillBackPic(data, 'checkPicture', 'checkPic');
        },
        onPicChange(files) {
            this.checkPic = files;
            this.$refs.form.clearValidate('checkPicture');
        },
        async validateFormData(type) {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    let maintenanceCheckUrls = [];
                    if (this.checkPic.length) {
                        maintenanceCheckUrls = await this.uploadToOss(this.checkPic).catch(() => {
                            this.$message('检测凭证图片上传失败');
                            throw new Error('检测凭证图片上传失败');
                        });
                        this.formData.checkPicture = maintenanceCheckUrls;
                    }
                    this.$emit('submit', { data: this.formData, type });
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.maintain-check {
    padding: 20px 0 20px 20px;
    flex: 1;
    .switch-box {
        display: flex;
        .switch-item {
            margin-right: 36px;
            .switch-star::before {
                content: '*';
                color: #F56C6C;
                margin-right: 4px;
            }
        }
    }
    .jump-tag {
        width: 60px;
        height: 30px;
        line-height: 28px;
        text-align: center;
        background: #F5F5F5;
        border: 1px solid #EEEEEE;
        border-radius: 4px;
        font-size: 14px;
        color: #999999;
        margin-bottom: 10px;
        font-weight: normal;
    }
    .info-operator {
        height: 18px;
        line-height: 18px;
        font-size: 12px;
        color: #999999;
        font-weight: 400;
    }
    .images {
        margin: 8px 0 0 0;
        display: flex;
        flex-wrap: wrap;
    }
    .remark-view {
        line-height: 22px;
        width: 400px;
        // padding-top: 5px;
    }
}
.pop-button {
    width: 44px;
    height: 24px;
    border-radius: 4px;
    padding: 0!important;
    font-size: 12px;
    color: rgba(0,0,0,0.65);
    border: 1px solid rgba(0,0,0,0.15);
    &.primary {
        color: #FFFFFF;
        background: #2970FF;
        border: none;
        margin-left: 8px;
    }
}
</style>

<style lang="scss">
.maintain-check {
    overflow-y: hidden;
    .el-form {
        max-height: 500px;
        overflow-y: auto;
    }
    .el-form .el-form-item__content {
        padding-left: 114px;
        .el-icon-date {
            line-height: normal !important;
        }
    }
    .switch {
        .el-form-item__content {
            padding-left: 0!important;
        }
    }
    .el-form-item__label {
        width: 114px;
        padding: 0;
    }
    .padding-left {
        .el-form-item__label {
            padding-left: 10px;
        }
    }
    .upload-pictures {
        .upload {
            height: auto;
            padding-left: 0!important;
            min-height: 80px;
        }
    }
    .el-form-item__error {
        margin-left: 114px;
    }
    .required-star {
        .el-form-item__label::before {
            content: '*';
            color: #F56C6C;
            margin-right: 4px;
        }
    }
    .el-upload-list__item.is-success .el-upload-list__item-status-label {
        display: none;
    }
    .el-textarea .el-input__count {
        border-bottom: 0;
        background-color: transparent!important;
    }
    ul.el-upload-list--picture-card {
        line-height: 0;
    }
    .upload-form-item .upload .el-upload--picture-card {
        margin-bottom: 8px;
    }
    .margin-bottom-12 {
        margin-bottom: 12px!important;
        .el-form-item__error {
            top: calc(100% - 8px);
        }
    }
    .small-margin {
        .el-form-item {
            margin-bottom: 12px!important;
            .el-form-item__label, .el-form-item__content {
                line-height: 22px;
            }
        }
    }
}
</style>
